import JSConfetti from 'js-confetti';

interface ConfettiOptions {
  emojis?: string[];
  emojiSize?: number;
  confettiNumber?: number;
}

export class Confetti {
  private jsConfetti: JSConfetti;

  constructor() {
    this.jsConfetti = new JSConfetti();
  }

  addConfetti(options?: ConfettiOptions) {
    this.jsConfetti.addConfetti(options);
  }

  clearCanvas() {
    this.jsConfetti.clearCanvas();
  }
}
